/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserBasicInfo
 */
export interface UserBasicInfo {
    /**
     * 
     * @type {string}
     * @memberof UserBasicInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserBasicInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserBasicInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserBasicInfo
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof UserBasicInfo
     */
    mlsId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserBasicInfo
     */
    emailConfirmed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserBasicInfo
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserBasicInfo
     */
    trackingId: string;
}

/**
 * Check if a given object implements the UserBasicInfo interface.
 */
export function instanceOfUserBasicInfo(value: object): value is UserBasicInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('mlsId' in value) || value['mlsId'] === undefined) return false;
    if (!('emailConfirmed' in value) || value['emailConfirmed'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('trackingId' in value) || value['trackingId'] === undefined) return false;
    return true;
}

export function UserBasicInfoFromJSON(json: any): UserBasicInfo {
    return UserBasicInfoFromJSONTyped(json, false);
}

export function UserBasicInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserBasicInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'status': json['status'],
        'mlsId': json['mlsId'],
        'emailConfirmed': json['emailConfirmed'],
        'enabled': json['enabled'],
        'trackingId': json['trackingId'],
    };
}

export function UserBasicInfoToJSON(json: any): UserBasicInfo {
    return UserBasicInfoToJSONTyped(json, false);
}

export function UserBasicInfoToJSONTyped(value?: UserBasicInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'status': value['status'],
        'mlsId': value['mlsId'],
        'emailConfirmed': value['emailConfirmed'],
        'enabled': value['enabled'],
        'trackingId': value['trackingId'],
    };
}

